export default "__VITE_ASSET__7467711a__"